"use client";

import { ArrowRight, Battery, Gauge, Weight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BreathingSleepExcellence() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: tickerRef,
    isVisible: tickerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const tickerItems = ["PULMONARY CONSULTATIONS", "SLEEP APNEA EVALUATION", "COPD & ASTHMA CARE", "CPAP FOLLOW-UP", "Chaudhry Pulmonary Associates"];
  const specs = [{
    icon: Battery,
    label: "OXYGEN",
    value: "CARE"
  }, {
    icon: Gauge,
    label: "SLEEP",
    value: "REST"
  }, {
    icon: Weight,
    label: "BREATH",
    value: "LIFE"
  }];
  return <section data-section-id="2727" id="breathing-sleep-excellence" className="bg-background text-foreground relative w-full min-h-[600px] md:min-h-[800px] md:h-screen overflow-hidden light" style={{
    backgroundImage: "url('https://strong-hare.10web.cloud/wp-content/uploads/2026/06/ChatGPT-Image-Jun-4-2026-03_28_54-PM-5-2.png')",
    backgroundSize: "auto 100%",
    backgroundPosition: "right center",
    backgroundRepeat: "no-repeat"
  }}>
      {}

      {}
      <div ref={cardRef} className={`absolute top-24 right-6 md:top-28 md:right-12 z-20 w-[240px] transition-all duration-1000 ease-out ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"}`} style={{
      transitionDelay: "600ms"
    }}>
        
      </div> 

      {}
      <div className="absolute inset-0 z-5 pointer-events-none" style={{
      background: "linear-gradient(to right, rgba(255,255,255,0.96) 0%, rgba(255,255,255,0.88) 42%, rgba(255,255,255,0.35) 72%, rgba(255,255,255,0.12) 100%)"
    }} />

      <div ref={contentRef} className="relative z-10 h-full flex flex-col justify-end max-w-[1600px] mx-auto px-6 md:px-12 lg:px-[120px] pb-40 md:pb-36 lg:pb-[120px] pt-24">
        <div className="max-w-[680px] w-full lg:w-[48%]">
          {}
          <div className={`flex items-center gap-4 mb-8 transition-all duration-700 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}><span className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-foreground" data-ast-id="f:/src/pages/Home/sections/BreathingSleepExcellence.tsx|sig:2f1tpu" data-ast-start="2473" data-ast-end="2630" contenteditable="false" style={{}}>Adult Pulmonary &amp; Sleep Medicine</span><span className="h-px bg-chart-2 transition-all duration-1000 ease-out w-16 md:w-24" data-ast-id="f:/src/pages/Home/sections/BreathingSleepExcellence.tsx|sig:a6afhz" data-ast-start="2643" data-ast-end="2821" style={{
            transitionDelay: '300ms'
          }}><br /></span></div>

          {}
          <h1 className={`font-default font-semibold text-foreground leading-[1.1] tracking-tight mb-8 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          fontSize: "clamp(2.5rem, 8vw, 4.5rem)",
          transitionDelay: "200ms"
        }}>
            Pulmonary & Sleep Medicine Care for Adults
          </h1>

          {}
          <p className={`font-default text-base md:text-lg text-muted-foreground leading-relaxed max-w-[480px] mb-4 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "500ms"
        }}>
            Chaudhry Pulmonary Associates provides adult pulmonary and sleep medicine care for breathing concerns, COPD, asthma, sleep apnea, chronic cough, shortness of breath, and related respiratory conditions.
          </p>

          <p className={`font-default text-base md:text-lg text-muted-foreground leading-relaxed max-w-[480px] mb-10 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "600ms"
        }}>
            Serving patients across the Greater Pittsburgh area.
          </p>

          {}
          <div className={`flex flex-col sm:flex-row gap-4 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "700ms"
        }}>
            <Link to="tel:+14126729240" className="group">
              <Button size="lg" className="h-14 px-8 bg-chart-3 text-primary hover:bg-chart-3/90 font-default font-bold text-sm uppercase tracking-widest shadow-md hover:shadow-lg hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto rounded-md">
                Call (412) 672-9240
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" strokeWidth={2} />
              </Button>
            </Link>
           <Link to="#our-clinical-focus" onClick={e => {
            e.preventDefault();
            document.getElementById('our-clinical-focus')?.scrollIntoView({
              behavior: 'smooth'
            });
          }}>
              <Button size="lg" variant="outline" className="h-14 px-8 bg-transparent border border-primary text-primary hover:bg-primary hover:text-background font-default font-bold text-sm uppercase tracking-widest transition-all duration-300 w-full sm:w-auto rounded-md">
                Our Services
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div ref={tickerRef} className={`absolute bottom-0 left-0 right-0 z-20 border-t border-b border-border bg-background/90 backdrop-blur-md overflow-hidden transition-opacity duration-1000 ${tickerVisible ? "opacity-100" : "opacity-0"}`} style={{
      transitionDelay: "900ms"
    }}>
        <div className="flex whitespace-nowrap py-4 animate-[marquee_30s_linear_infinite]">
          {[...Array(4)].map((_, repeatIdx) => <div key={repeatIdx} data-index={repeatIdx} className="flex items-center shrink-0">
              {tickerItems.map((item, i) => <div key={`${repeatIdx}-${i}`} data-index={i} className="flex items-center shrink-0">
                  <span className="font-mono text-xs md:text-sm uppercase tracking-[0.2em] font-medium text-foreground px-6">
                    {item}
                  </span>
                  <span className="text-chart-2 text-xs rotate-45 inline-block w-2 h-2 bg-chart-2" />
                </div>)}
            </div>)}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}